import { render, staticRenderFns } from "./NewProjectWizardButtons.vue?vue&type=template&id=e00a5486&scoped=true&"
import script from "./NewProjectWizardButtons.vue?vue&type=script&lang=js&"
export * from "./NewProjectWizardButtons.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectWizardButtons.vue?vue&type=style&index=0&id=e00a5486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00a5486",
  null
  
)

export default component.exports